/* eslint-disable no-unused-vars */
import { useState, useEffect } from 'react';
export default function InstallPrompt() {
  const [prompt, setPrompt] = useState(null);
  const [show, setShow] = useState(false);
  useEffect(() => {
    const handler = e => { e.preventDefault(); setPrompt(e); setShow(true); };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);
  if (!show) return null;
  return (
    <div style={{position:'fixed',bottom:80,left:16,right:16,zIndex:500,background:'#161b22',border:'1px solid #21262d',borderRadius:14,padding:'14px 16px',display:'flex',alignItems:'center',gap:12,boxShadow:'0 8px 32px rgba(0,0,0,.6)'}}>
      <div style={{flex:1}}>
        <div style={{fontSize:13,fontWeight:700,color:'#fff',marginBottom:3}}>Install Rent Lord</div>
        <div style={{fontSize:11,color:'#8b949e'}}>Add to your home screen for the best experience.</div>
      </div>
      <button onClick={async()=>{ prompt.prompt(); const{outcome}=await prompt.userChoice; if(outcome==='accepted') setShow(false); }} style={{padding:'8px 16px',borderRadius:8,background:'linear-gradient(135deg,#16a34a,#4ade80)',color:'#0a1a0a',border:'none',fontSize:12,fontWeight:700,cursor:'pointer',whiteSpace:'nowrap'}}>Install</button>
      <button onClick={()=>setShow(false)} style={{background:'none',border:'none',color:'#484f58',cursor:'pointer',fontSize:18,padding:'4px'}}>×</button>
    </div>
  );
}
